import { IUser } from '@app/core/authentication';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IContactUsList } from '@app/core/models/contact-us.interface';

@Injectable({
  providedIn: 'root'
})
export class IdentityProvider {

  /* tslint:disable:variable-name */
  private _currentUser: IUser;
  isCurrentUserSet = new BehaviorSubject<boolean>(undefined);
  isContactUsListSet = new BehaviorSubject<boolean>(undefined);
  contactUsLists: IContactUsList;

  public get currentUser() {
    return Object.assign({}, this._currentUser);
  }
  public get contactUsList() {
    return this.contactUsLists;
  }
  constructor() {
  }
  public setCurrentUser(user: IUser): void {
    this._currentUser = { ...user };
    this.isCurrentUserSet.next(true);
  }
  public setContactUsList(contactUsList: IContactUsList): void {
    this.contactUsLists = contactUsList;
    this.isContactUsListSet.next(true);
  }

  public hasClaimFormAccess(): boolean {
    return this._currentUser?.userProfile?.hasClaimForm === 'Y';
  }

  public hasClaimTrackingAccess(): boolean {
    const blockedNetworkIds = ['VWRK', 'VWRKQ', 'WALM', 'WALMQ'];
    const blockedNetworkIdsAllStates = ['VWM', 'WMM'];
    const serviceTypes = ['FS', 'DL'];
    const hasAllStateNetworkId = this._currentUser?.userProfile?.networkIds.some(network => blockedNetworkIdsAllStates.some(nw => network.indexOf(nw) === 0));
    const hasNetworkId = this._currentUser?.userProfile?.networkIds.some(network => blockedNetworkIds.indexOf(network) > -1);
    return !(
      serviceTypes.includes(this._currentUser.userProfile.serviceType) &&
      (
        hasAllStateNetworkId ||
        hasNetworkId
      )
    );
  }

  public isCCDispensary(): boolean {
    const ccUserCodes = ['COSTA', 'COSTC', 'COSTQ'];

    return this._currentUser.userProfile.networkIds.some(network => ccUserCodes.indexOf(network) > -1)
      && this._currentUser.userProfile.serviceType === 'DL';

  }
}
